<template>
  <div class="uk-margin">
    <label class="uk-form-label uk-display-block">
      {{ label }}{{ required ? '*' : '' }}
    </label>

    <div class="kmc-field-help-text" v-if="helpText">
      {{ helpText }}
    </div>

    <div class="uk-form-controls">
      <div class="kmc-select">
        <select ref="input" v-model="inputValue" :name="name" :aria-label="label" @input="handleChange"
          @blur="handleBlur">
          <option value="" disabled selected hidden>
            Please select...
          </option>
          <option v-for="option in options" :value="option.value">
            {{ option.label }}
          </option>
        </select>
        <div class="arrow"></div>
      </div>
    </div>

    <div class="kmc-field-error-text">
      {{ errorMessage }}
    </div>

  </div>
</template>

<script>
import { ref, watch } from 'vue';
import { useField } from "vee-validate";

export default {
  name: "KmcInputDropdown",
  props: {
    helpText: {
      type: String,
    },
    required: {},
    value: {
      type: String,
      default: "",
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    options: {
      type: Array,
    }
  },
  setup: function (props, context) {

    const input = ref(null)

    const {
      value: inputValue,
      errorMessage,
      meta,
      handleBlur,
      handleChange,
    } = useField(props.name, undefined, {
      initialValue: props.value,
    });


    watch(errorMessage, (current, previous) => {
      input.value.setCustomValidity(current || '');
    })


    return {
      input,
      errorMessage,
      inputValue,
      meta,
      handleBlur,
      handleChange
    };
  }
}

</script>
